/*
 * ******************************************************************
 * Copyright (c) 2019-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { Event } from "@app/services/dispatcher/events/event";
import { TaskV2 } from "@api/generated/vcdr";
import { HttpErrorResponse } from "@angular/common/http";

export class ErrorOccurredEvent extends Event {
    public static ID: string = "ERROR_OCCURRED";

    public httpError: HttpErrorResponse;
    public task: TaskV2;
    public isNew: boolean = true;
    public title: string = "";
    public detail: string = "";

    private constructor() {
        super(ErrorOccurredEvent.ID);
    }

    static fromTask(task: TaskV2, isNew: boolean = true): ErrorOccurredEvent {
        const result: ErrorOccurredEvent = new ErrorOccurredEvent();
        result.task = task;
        result.isNew = isNew;
        return result;
    }

    static fromHttpError(error: HttpErrorResponse): ErrorOccurredEvent {
        const result: ErrorOccurredEvent = new ErrorOccurredEvent();
        result.httpError = error;
        return result;
    }

    static fromMessages(title: string, detail: string): ErrorOccurredEvent {
        const result: ErrorOccurredEvent = new ErrorOccurredEvent();
        result.title = title;
        result.detail = detail;
        return result;
    }
}
